export default __webpack_public_path__ + "static/media/PlusCircle (1).68f57010.svg";